import {
  DrawdownBookingStep,
  DrawdownLoadingOverlay,
  DrawdownMarketingVariant1,
  DrawdownQuoteResultsStep,
} from "../../../Components/LanderV2/drawdowncalculator-v1/VariantV1";
import { LanderV2CampaignConfig } from "./types";
import { pensionFundQuestion, personalDetailQuestions, sharedSurveyProps } from "./shared";

export const drawdowncalculatorV1: LanderV2CampaignConfig = {
  slug: "drawdowncalculator-ux2-v1",
  heading: "How long could your pension last in drawdown?",
  subheading: "Explore your pension drawdown options in as little as 2 minutes.",
  proofLine: "Compare drawdown flexibility with leading UK annuity quotes.",
  accent: "magenta",
  surveyFormId: "drawdowncalculator-ux2-v1",
  landingPageTheme: "Pense Variant 1",
  landingPageVariation: "drawdowncalculator-ux2-v1",
  landingPageVersion: "ux2-v1",
  initialData: {},
  surveyProps: sharedSurveyProps,
  MarketingComponent: DrawdownMarketingVariant1,
  steps: [
    {
      slug: "quote-entry",
      isEntry: true,
      completeText: "GET MY OPTIONS",
      schemaPage: {
        name: "quoteEntry",
        elements: [
          pensionFundQuestion,
          {
            type: "ageinput",
            name: "dateOfBirth",
            title: "Your Age Now",
            isRequired: true,
          },
          {
            type: "retirementdate",
            name: "annuity.plannedRetirementDate",
            title: "Date you plan to retire",
            isRequired: true,
          },
        ],
      },
    },
    {
      slug: "personal-details",
      next: "quotes",
      completeText: "CALCULATE",
      fetchesQuotes: true,
      LoadingComponent: DrawdownLoadingOverlay,
      schemaPage: {
        name: "personalDetails",
        title: "Good news! We have some great drawdown options waiting for you",
        description: "To check eligibility and store your options securely, we just need a little information",
        elements: personalDetailQuestions,
      },
      layoutClassName: "pa-v1-personal-survey",
      disableCompleteUntilCurrentPageComplete: true,
      illustrationSrc: "/media/illustrations/BW/PNG/like.png",
      illustrationAlt: "",
    },
    {
      slug: "quotes",
      Component: DrawdownQuoteResultsStep,
      previous: "personal-details",
      completeText: "Finish",
      startOverOnNav: true,
      schemaPage: {
        name: "quotes",
        title: "Your drawdown options are ready",
        elements: [],
      },
    },
    {
      slug: "booking",
      Component: DrawdownBookingStep,
      previous: "quotes",
      completeText: "Book",
      startOverOnNav: false,
      schemaPage: {
        name: "booking",
        title: "Book an appointment",
        elements: [],
      },
    },
  ],
};
